// extracted by mini-css-extract-plugin
module.exports = {"action":"style_action__hEdFK","action-icon":"style_action-icon__L8Ao0"};